import { CalendarDays } from "lucide-react";

const MONTH_NAMES = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno",
  "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];

const iso = (d) => d.toISOString().slice(0, 10);
const dm = (d) => `${String(d.getUTCDate()).padStart(2, "0")}/${String(d.getUTCMonth() + 1).padStart(2, "0")}`;

export function monthOptions(count = 12) {
  const now = new Date();
  const out = [];
  for (let i = 0; i < count; i++) {
    const y = now.getUTCFullYear();
    const m = now.getUTCMonth() - i;
    const first = new Date(Date.UTC(y, m, 1));
    const last = new Date(Date.UTC(y, m + 1, 0));
    out.push({
      key: `m-${iso(first)}`,
      label: `${MONTH_NAMES[first.getUTCMonth()]} ${first.getUTCFullYear()}`,
      date_from: iso(first),
      date_to: iso(last),
    });
  }
  return out;
}

export function weekOptions(count = 12) {
  const now = new Date();
  const today = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
  const dow = (today.getUTCDay() + 6) % 7; // 0 = lunedì
  const monday = new Date(today);
  monday.setUTCDate(today.getUTCDate() - dow);
  const out = [];
  for (let i = 0; i < count; i++) {
    const from = new Date(monday);
    from.setUTCDate(monday.getUTCDate() - i * 7);
    const to = new Date(from);
    to.setUTCDate(from.getUTCDate() + 6);
    out.push({
      key: `w-${iso(from)}`,
      label: `dal ${dm(from)} al ${dm(to)}`,
      date_from: iso(from),
      date_to: iso(to),
    });
  }
  return out;
}

export const DEFAULT_PERIOD = { mode: "month", ...monthOptions(1)[0] };

// Parametri da passare alle API analytics
export function periodParams(period) {
  if (period.mode === "all") return { days: 0 };
  return { date_from: period.date_from, date_to: period.date_to, days: 0 };
}

const MODES = [
  { id: "month", label: "Mesi" },
  { id: "week", label: "Settimane" },
  { id: "all", label: "Sempre" },
];

export default function PeriodPicker({ value, onChange, testPrefix = "period" }) {
  const options = value.mode === "month" ? monthOptions() : value.mode === "week" ? weekOptions() : [];

  const setMode = (mode) => {
    if (mode === "all") onChange({ mode: "all", label: "sempre (tutti i dati)" });
    else if (mode === "month") onChange({ mode, ...monthOptions(1)[0] });
    else onChange({ mode, ...weekOptions(1)[0] });
  };

  return (
    <div className="space-y-2" data-testid={`${testPrefix}-picker`}>
      <div className="flex flex-wrap items-center gap-2">
        <span className="mr-1 flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-muted-foreground">
          <CalendarDays className="h-4 w-4" /> Periodo
        </span>
        {MODES.map((m) => (
          <button
            key={m.id}
            data-testid={`${testPrefix}-mode-${m.id}`}
            onClick={() => setMode(m.id)}
            className={`rounded-full px-4 py-1.5 text-sm font-semibold transition-colors ${
              value.mode === m.id
                ? "bg-slate-900 text-white shadow-sm"
                : "border border-border bg-secondary/40 text-muted-foreground hover:bg-secondary"
            }`}
          >
            {m.label}
          </button>
        ))}
      </div>
      {options.length > 0 && (
        <div className="flex gap-2 overflow-x-auto pb-1" data-testid={`${testPrefix}-options`}>
          {options.map((o) => (
            <button
              key={o.key}
              data-testid={`${testPrefix}-option-${o.key}`}
              onClick={() => onChange({ mode: value.mode, ...o })}
              className={`flex-shrink-0 whitespace-nowrap rounded-full px-3 py-1 text-xs font-semibold transition-colors ${
                value.key === o.key
                  ? "bg-blue-600 text-white shadow-sm"
                  : "border border-border bg-white text-muted-foreground hover:bg-secondary"
              }`}
            >
              {o.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
